import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Patient from "./pages/Patient";
import Viewer from "./pages/Viewer";
import ManageTemplate from "./components/sidebar_tools/ManageTemplate";
import AnalyticsSection from "./components/AnalyticsSection";
import DataTable from "./components/DataTable";
import ProtectedRoute from "./ProtectedRoute";
import LayoutWithSidebar from "./components/LayoutWithSidebar"

function App() {
  return (
    <BrowserRouter>
      <Routes>

      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />

        {/* <Route
          path="/"
          element={
            <ProtectedRoute allowedRoles={["admin","center"]}>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<AnalyticsSection />} />
          <Route path="patient" element={<Patient />} />
          <Route path="report-format" element={<ManageTemplate />} />
          <Route path="study-list" element={<DataTable activeToolId={0} />} />
        </Route> */}
 <Route element={<LayoutWithSidebar />}>
      <Route path="/dashboard" element={<AnalyticsSection />} />
      <Route path="/patient" element={<Patient />} />
      <Route path="/study-list" element={<DataTable activeToolId={0} />} />
      <Route path="/report-format" element={<ManageTemplate />} />
      <Route path="/viewer/:patientId" element={<Viewer />} />
    </Route>
        <Route path="/viewer/:patientId" element={<Viewer />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;